import React, { Fragment, useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import Breadcrumb from "../../../layout/breadcrumb";
import { Card, CardBody, Col, Container, Row, Button } from "reactstrap";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import PreLoader from "../../../share-components/ui/preLoader";
import withReducer from "../../../store/withReducer";
import productReducer from "../../manage-product/store";
import DateRangePickerPrimary from "../../../share-components/ui/DateRangePickerPrimary";
import Select from "react-select";
import { getPriceReductionRequestsApi, getPriceReductionRequestFilterOptionsApi } from "../../../services/manage-product/productService";
import moment from "moment";

const dataMenu = [
  {
    type: 0,
    text: "Price Reduction Requests",
  },
];

const afterToday = () => {
  return (date) => date.getTime() > new Date().getTime();
};

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 100 }),
};

const PriceReductionsRequest = () => {
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const endDateObj = new Date();
  const startDateObj = new Date();
  startDateObj.setDate(endDateObj.getDate() - 90);
  const [dateRange, setDateRange] = useState([startDateObj, endDateObj]);

  const [filterRequestedBy, setFilterRequestedBy] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);
  const [filterApprovedBy, setFilterApprovedBy] = useState(null);
  const [requestedByOptions, setRequestedByOptions] = useState([]);
  const [approvedByOptions, setApprovedByOptions] = useState([]);

  const statusOptions = [
    { value: "pending", label: "Pending" },
    { value: "approve", label: "Approved" },
    { value: "declined", label: "Declined" },
  ];

  const fetchRequests = useCallback(() => {
    setLoading(true);
    const filters = {
      page: page,
      page_size: pageSize,
      sort: "created_at-desc",
    };

    if (dateRange[0]) {
      filters.start_date = moment(dateRange[0]).format("YYYY-MM-DD");
    }
    if (dateRange[1]) {
      filters.end_date = moment(dateRange[1]).format("YYYY-MM-DD");
    }
    if (filterRequestedBy?.value) {
      filters.requested_by = filterRequestedBy.value;
    }
    if (filterStatus?.value) {
      filters.status = filterStatus.value;
    }
    if (filterApprovedBy?.value) {
      filters.approved_by = filterApprovedBy.value;
    }

    getPriceReductionRequestsApi(filters)
      .then((res) => {
        if (res.response && res.response.data) {
          setRequests(res.response.data);
          setTotalRows(res.response.pagination?.total || 0);
        } else {
          setRequests([]);
          setTotalRows(0);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching price reduction requests:", error);
        setRequests([]);
        setTotalRows(0);
        setLoading(false);
      });
  }, [page, pageSize, dateRange, filterRequestedBy, filterStatus, filterApprovedBy]);

  const fetchFilterOptions = useCallback(() => {
    const filters = {};

    if (dateRange[0]) {
      filters.start_date = moment(dateRange[0]).format("YYYY-MM-DD");
    }
    if (dateRange[1]) {
      filters.end_date = moment(dateRange[1]).format("YYYY-MM-DD");
    }
    if (filterRequestedBy?.value) {
      filters.requested_by = filterRequestedBy.value;
    }
    if (filterStatus?.value) {
      filters.status = filterStatus.value;
    }
    if (filterApprovedBy?.value) {
      filters.approved_by = filterApprovedBy.value;
    }

    getPriceReductionRequestFilterOptionsApi(filters)
      .then((res) => {
        if (res.response) {
          setRequestedByOptions(res.response.requested_by || []);
          setApprovedByOptions(res.response.approved_by || []);
        } else {
          setRequestedByOptions([]);
          setApprovedByOptions([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching price reduction request filters:", error);
        setRequestedByOptions([]);
        setApprovedByOptions([]);
      });
  }, [dateRange, filterRequestedBy, filterStatus, filterApprovedBy]);

  useEffect(() => {
    fetchRequests();
  }, [fetchRequests]);

  useEffect(() => {
    fetchFilterOptions();
  }, [fetchFilterOptions]);

  const tableColumns = [
    {
      name: "Requested Date",
      selector: (row) => row.requested_date,
      sortable: true,
      center: false,
      grow: 1,
    },
    {
      name: "Requested By",
      selector: (row) => row.requested_by,
      cell: (row) => <div style={{ width: '100%', textAlign: 'center' }}>{row.requested_by}</div>,
      sortable: true,
      center: true,
      grow: 1,
    },
    {
      name: "Product Count",
      selector: (row) => row.product_count,
      sortable: true,
      center: true,
      grow: 1,
    },
    {
      name: "Approved/Declined By",
      selector: (row) => row.approved_by || "-",
      sortable: false,
      center: true,
      grow: 1,
    },
    {
      name: "Status",
      selector: (row) => row.status_display,
      cell: (row) => {
        return (
          <span
            style={{
              color: "#9e9e9e",
              fontSize: "11px",
              fontWeight: "normal",
            }}
          >
            {row.status_display}
          </span>
        );
      },
      sortable: true,
      center: true,
      grow: 1,
    },
    {
      name: "Action",
      selector: (row) => row.id,
      cell: (row) => (
        <Button
          className="btn-sm price-reduction-action-btn"
          style={{
            backgroundColor: "#3e4a56",
            color: "white",
            border: "none",
            borderRadius: "4px",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            padding: "0",
            minWidth: "32px",
          }}
          onClick={() => {
            history.push(`/product/price-reductions-request/${row.id}/view`);
          }}
        >
          <i className="fa fa-eye" style={{ fontSize: "12px", color: "#ffffff" }}></i>
        </Button>
      ),
      sortable: false,
      center: true,
      grow: 1,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb title="Price Reduction Requests" data={dataMenu} />
      <Container fluid={true} className="product-wrapper">
        <div className="product-grid">
          <div className="feature-products">
            <style>
              {`
                .product-table .rdt_Table {
                  width: 100% !important;
                }
                .product-table .rdt_TableHeader {
                  min-height: 40px !important;
                }
                .product-table .rdt_TableCol {
                  padding: 8px 5px !important;
                  height: auto !important;
                  min-height: 40px !important;
                  display: flex !important;
                  align-items: center !important;
                  font-size: 12px !important;
                  font-weight: bold !important;
                  color: #68646d !important;
                  flex: 1 1 0 !important;
                  max-width: none !important;
                }
                .product-table .rdt_TableCell {
                  font-size: 11px !important;
                  padding: 5px !important;
                  flex: 1 1 0 !important;
                  max-width: none !important;
                }
                .product-table .rdt_TableRow {
                  font-size: 11px !important;
                }
                .product-table .fa-eye {
                  color: #ffffff !important;
                }
                .product-table .price-reduction-action-btn {
                  background-color: #3e4a56 !important;
                }
                .product-table .price-reduction-action-btn:hover,
                .product-table .price-reduction-action-btn:focus,
                .product-table .price-reduction-action-btn:active {
                  background-color: #3e4a56 !important;
                }
              `}
            </style>
            <Card className="mb-3" style={{ marginBottom: "1rem" }}>
              <CardBody style={{ padding: "4px 8px" }}>
                <Row className="align-items-center" style={{ gap: "12px", flexWrap: "wrap" }}>
                  <Col md="auto" style={{ paddingRight: "0", flex: "0 0 auto" }}>
                    <DateRangePickerPrimary
                      dateRange={dateRange}
                      dateRangeChange={(date) => {
                        setDateRange(date);
                        setPage(1);
                      }}
                      defaultValue={[startDateObj, endDateObj]}
                      disabledDate={afterToday()}
                    />
                  </Col>
                  <Col md="auto" style={{ paddingRight: "0", flex: "1 1 0", minWidth: "150px" }}>
                    <Select
                      className="select2-filter"
                      isClearable
                      options={requestedByOptions}
                      value={filterRequestedBy}
                      placeholder="Requested By"
                      styles={customStyles}
                      menuPortalTarget={document.body}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      onChange={(e) => {
                        setFilterRequestedBy(e);
                        setPage(1);
                      }}
                    />
                  </Col>
                  <Col md="auto" style={{ paddingRight: "0", flex: "1 1 0", minWidth: "150px" }}>
                    <Select
                      className="select2-filter"
                      isClearable
                      value={filterStatus}
                      placeholder="Status"
                      options={statusOptions}
                      styles={customStyles}
                      menuPortalTarget={document.body}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      onChange={(e) => {
                        setFilterStatus(e);
                        setPage(1);
                      }}
                    />
                  </Col>
                  <Col md="auto" style={{ paddingRight: "0", flex: "1 1 0", minWidth: "150px" }}>
                    <Select
                      className="select2-filter"
                      isClearable
                      options={approvedByOptions}
                      value={filterApprovedBy}
                      placeholder="Approved/Declined By"
                      styles={customStyles}
                      menuPortalTarget={document.body}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                      onChange={(e) => {
                        setFilterApprovedBy(e);
                        setPage(1);
                      }}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardBody style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem', paddingBottom: '1rem' }}>
                <div className="product-table" style={{ width: '100%', overflowX: 'hidden', margin: '0', marginTop: '0.5rem' }}>
                  {loading ? (
                    <div style={{ minHeight: 150 }}>
                      <PreLoader />
                    </div>
                  ) : (
                    <CommonDataTable
                      headerColumns={tableColumns}
                      gridData={requests}
                      noAction
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationRowsPerPageOptions={[10, 25, 50, 100]}
                      paginationDefaultPage={page}
                      paginationPerPage={pageSize}
                      onChangePage={(page) => setPage(page)}
                      onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                        setPageSize(currentRowsPerPage);
                        setPage(currentPage);
                      }}
                    />
                  )}
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </Container>
    </Fragment>
  );
};

export default withReducer([{ product: productReducer }])(PriceReductionsRequest);

